export default "__VITE_ASSET__BZQ6CcW3__"